import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import {
  NewsletterSplitTestInterface,
  NewsletterSplitTestUpdateInterface,
} from 'modules/newsletters/split-test/types/newsletter-split-test-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useUpdateNewsletterSplitTestSettings = (newsletterId: NewsletterId) => {
  const { fetcher } = useFetch<RequestMethodsEnum.put, NewsletterSplitTestInterface>({
    method: RequestMethodsEnum.put,
  })

  return {
    fetcherUpdateNewsletterSplitTestSettings: (payload: NewsletterSplitTestUpdateInterface) =>
      fetcher(`${NEWSLETTERS_API}/${newsletterId}/split-test`, payload),
  }
}
